<template>
	<div class="main" v-loading.fullscreen="isLoad" router element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb class="bnone">
			<el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Basics/brand.html')">系统设置</div></el-breadcrumb-item>
			<el-breadcrumb-item>存储配置</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form ref="form" label-position="right" :model="item" label-width="200px" show-message inline-message
			status-icon>
			<el-form-item label="上传方式">
				<el-radio-group v-model="item.default">
					<el-radio :label="item.value" :key="index" :value="item.value" v-for="(item, index) in StorageEnum.data">{{ item.name }} {{ item.value == StorageEnum.LOCAL.value ? '(不推荐)' : '' }}</el-radio>
				</el-radio-group>
			</el-form-item>
			<div v-if="item.default == StorageEnum.QINIU.value">
				<el-form-item label="存储空间名称 Bucket">
					<el-input v-model="item.engine.qiniu.bucket"></el-input>
				</el-form-item>
				<el-form-item label="ACCESS_KEY AK">
					<el-input v-model="item.engine.qiniu.access_key"></el-input>
				</el-form-item>
				<el-form-item label="SECRET_KEY SK">
					<el-input v-model="item.engine.qiniu.secret_key"></el-input>
				</el-form-item>
				<el-form-item label="空间域名 Domain">
					<el-input v-model="item.engine.qiniu.domain"></el-input>
				</el-form-item>
			</div>
			<el-form-item>
				<el-button type="primary" @click="submit" v-auth="['admin/setting/storageSave']">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	import StorageEnum from '@/common/enum/file/Storage'

	export default {
		data() {
			return {
				item: {
					default: 'local'
				},
				isLoad: false,
				// 枚举类
				StorageEnum
			}
		},
		created() {
			this.loadItem()
		},
		methods: {
			gotopage(url){
				var link =  this.$router.resolve({
					path: url
				});
				window.open(link.href, '_blank')
			},
			loadItem() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.get('/admin/setting/storage').then(res => {
					this.isLoad = !this.isLoad
					if(res.data){
						this.item = res.data
					}
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			submit() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.post('/admin/setting/storageSave', {
					form: this.item
				}).then(res => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '保存成功'
					});
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			}
		}
	}
</script>
<style>
</style>
